"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.object.keys");
require("core-js/modules/web.dom.iterable");
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("core-js/modules/es6.string.starts-with");
require("core-js/modules/es6.array.find");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _MemberForm = _interopRequireDefault(require("./components/MemberForm.vue"));
var _memberRechargeRecord = _interopRequireDefault(require("./memberRechargeRecord"));
var _CouponManagement = _interopRequireDefault(require("./components/CouponManagement.vue"));
var _ExchangeList = _interopRequireDefault(require("./components/ExchangeList.vue"));
var _MemberOrder = _interopRequireDefault(require("./components/MemberOrder.vue"));
var _OrderDetail = _interopRequireDefault(require("@/components/OrderDetail"));
var _AccountChangeDetail = _interopRequireDefault(require("./components/AccountChangeDetail.vue"));
var _MemberAddress = _interopRequireDefault(require("./components/MemberAddress.vue"));
var _MemberLog = _interopRequireDefault(require("./components/MemberLog.vue"));
var _MemberSummary = _interopRequireDefault(require("./components/MemberSummary.vue"));
var _CouponDetail = _interopRequireDefault(require("./components/CouponDetail.vue"));
var _memberManagement = require("@/api/member/memberManagement");
var _gradeInfo = require("@/api/basic/gradeInfo");
var _index = require("@/utils/index");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: '会员列表',
  components: {
    MemberForm: _MemberForm.default,
    memberRechargeRecord: _memberRechargeRecord.default,
    CouponManagement: _CouponManagement.default,
    ExchangeList: _ExchangeList.default,
    MemberOrder: _MemberOrder.default,
    OrderDetail: _OrderDetail.default,
    AccountChangeDetail: _AccountChangeDetail.default,
    MemberAddress: _MemberAddress.default,
    MemberLog: _MemberLog.default,
    MemberSummary: _MemberSummary.default,
    CouponDetail: _CouponDetail.default
  },
  data: function data() {
    return {
      // 微信配置
      wechatConfig: [{
        label: '点餐',
        appid: 'GAGAX'
      }, {
        label: '社交',
        appid: 'GAGAS'
      }, {
        label: '支付宝',
        appid: 'ALIX'
      }],
      // 搜索表单数据
      searchForm: {
        userId: '',
        thirdUserId: '',
        mobilePhone: '',
        regTimeRange: [],
        registerType: '',
        cardType: '',
        cardName: '',
        cardNo: '',
        openId: '',
        unionid: '',
        wxType: ''
      },
      // 卡型列表
      cardTypeList: [],
      // 高级筛选显示状态
      showAdvanced: false,
      // 表格数据
      tableData: [],
      // 加载状态
      loading: false,
      // 分页相关
      currentPage: 1,
      pageSize: 10,
      total: 0,
      // 标签页相关
      activeTab: 'list',
      // 当前激活的标签页
      editTabs: [],
      // 编辑标签页列表
      tabIndex: 0,
      // 标签页索引计数器
      imgPath: process.env.VUE_APP_COMMENT_IMAGE_URL // 图片路径
    };
  },
  methods: {
    // 搜索功能
    handleSearch: function handleSearch() {
      this.currentPage = 1;
      this.fetchMemberList();
    },
    // 解绑微信openid
    unbindOpenId: function () {
      var _unbindOpenId2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(openid, userId) {
        var _this = this;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (openid) {
                _context2.next = 1;
                break;
              }
              this.$message.error('请选择要解绑的openid');
              return _context2.abrupt("return");
            case 1:
              if (userId) {
                _context2.next = 2;
                break;
              }
              this.$message.error('请选择要解绑的会员');
              return _context2.abrupt("return");
            case 2:
              this.$confirm('确定要解绑该openid吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var response, _t;
                return regeneratorRuntime.wrap(function (_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      _context.prev = 0;
                      _context.next = 1;
                      return (0, _memberManagement.unbindOpenId)(openid, userId);
                    case 1:
                      response = _context.sent;
                      if (response.code === 0) {
                        _this.$message.success('解绑成功');
                        _this.fetchMemberList();
                      } else {
                        _this.$message.error(response.message || '解绑失败');
                      }
                      _context.next = 3;
                      break;
                    case 2:
                      _context.prev = 2;
                      _t = _context["catch"](0);
                      console.error('解绑openid失败:', _t);
                      _this.$message.error('解绑openid失败');
                    case 3:
                    case "end":
                      return _context.stop();
                  }
                }, _callee, null, [[0, 2]]);
              }))).catch(function () {
                _this.$message.info('已取消解绑');
              });
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function unbindOpenId(_x, _x2) {
        return _unbindOpenId2.apply(this, arguments);
      }
      return unbindOpenId;
    }(),
    // 根据openId绑定情况和企微状态返回渠道图标列表
    getChannelIcons: function getChannelIcons(row) {
      var icons = [];
      if (this.getOpenId(row.openIds, 'DELI') || this.getOpenId(row.openIds, 'GAGAX')) {
        icons.push({
          label: '点餐',
          src: require('@/assets/icons/wx.png')
        });
      }
      if (this.getOpenId(row.openIds, 'GAGAS')) {
        icons.push({
          label: '社区',
          src: require('@/assets/icons/comm.png')
        });
      }
      if (this.getOpenId(row.openIds, 'ALIX')) {
        icons.push({
          label: '支付宝',
          src: require('@/assets/icons/icon_ali.png')
        });
      }
      if (row.isWw) {
        icons.push({
          label: '企微',
          src: require('@/assets/icons/icon_ww.png')
        });
      }
      return icons;
    },
    getOpenId: function getOpenId(openIds, appid) {
      console.log('openIds', openIds);
      if (!openIds || !Array.isArray(openIds)) return '';
      var item = openIds.find(function (item) {
        return item.appid === appid;
      });
      console.log('item', item);
      return item ? item.openid : '';
    },
    // 处理头像URL，确保正确的前缀
    getAvatarUrl: function getAvatarUrl(userpic) {
      if (!userpic) return '';
      // 如果已经是http开头，直接返回
      if (userpic.startsWith('http://') || userpic.startsWith('https://')) {
        return userpic;
      }
      // 否则添加前缀
      return this.imgPath + userpic;
    },
    // 获取会员列表
    fetchMemberList: function () {
      var _fetchMemberList = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var params, response, _t2;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              this.loading = true;
              _context3.prev = 1;
              params = _objectSpread(_objectSpread({}, this.searchForm), {}, {
                page: this.currentPage,
                // 当前页码
                limit: this.pageSize // 每页条数
              }); // 处理时间范围数据
              if (this.searchForm.regTimeRange && this.searchForm.regTimeRange.length === 2) {
                params.regTimeStart = this.searchForm.regTimeRange[0];
                params.regTimeEnd = this.searchForm.regTimeRange[1];
              }
              // 删除regTimeRange字段，因为后端不需要这个字段
              delete params.regTimeRange;

              // 过滤空值参数
              Object.keys(params).forEach(function (key) {
                if (params[key] === '' || params[key] === null || params[key] === undefined) {
                  delete params[key];
                }
              });
              _context3.next = 2;
              return (0, _memberManagement.xyUsersPage)(params);
            case 2:
              response = _context3.sent;
              if (response.code === 200) {
                this.tableData = response.records || [];
                this.total = response.total || 0;
              } else {
                this.$message.error(response.message || '获取会员列表失败');
              }
              _context3.next = 4;
              break;
            case 3:
              _context3.prev = 3;
              _t2 = _context3["catch"](1);
              console.error('获取会员列表失败:', _t2);
              this.$message.error('获取会员列表失败');
            case 4:
              _context3.prev = 4;
              this.loading = false;
              return _context3.finish(4);
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[1, 3, 4, 5]]);
      }));
      function fetchMemberList() {
        return _fetchMemberList.apply(this, arguments);
      }
      return fetchMemberList;
    }(),
    // 切换高级筛选显示/隐藏
    toggleAdvanced: function toggleAdvanced() {
      this.showAdvanced = !this.showAdvanced;
    },
    // 关闭Popover菜单
    closePopover: function closePopover(userId) {
      var _this2 = this;
      // 兼容处理：支持id和userId字段
      var id = userId || arguments[0];
      this.$nextTick(function () {
        var popover = _this2.$refs["popover-".concat(id)];
        if (popover && Array.isArray(popover)) {
          popover[0].doClose();
        } else if (popover) {
          popover.doClose();
        }
      });
    },
    /**
     * 添加会员
     * 创建新的标签页用于添加会员信息
     */
    handleAdd: function handleAdd() {
      var newTabName = "add-".concat(++this.tabIndex);
      this.editTabs.push({
        title: '添加会员',
        name: newTabName,
        type: 'add',
        memberData: null
      });
      this.activeTab = newTabName;
    },
    // 导出会员
    exportMembers: function () {
      var _exportMembers2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var params, response, _t3;
        return regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              this.$message.info('正在导出会员数据...');
              params = _objectSpread({}, this.searchForm); // 处理时间范围数据
              if (this.searchForm.regTimeRange && this.searchForm.regTimeRange.length === 2) {
                params.regTimeStart = this.searchForm.regTimeRange[0];
                params.regTimeEnd = this.searchForm.regTimeRange[1];
              }
              // 删除regTimeRange字段，因为后端不需要这个字段
              delete params.regTimeRange;

              // 过滤空值参数
              Object.keys(params).forEach(function (key) {
                if (params[key] === '' || params[key] === null || params[key] === undefined) {
                  delete params[key];
                }
              });
              _context4.next = 1;
              return (0, _memberManagement.exportMembers)(params);
            case 1:
              response = _context4.sent;
              if (response && response.code === 200) {
                this.$message.success(response.message || '数据导出中，请稍后查看下载文件');
              } else {
                this.$message.error(response.message || '导出失败');
              }
              _context4.next = 3;
              break;
            case 2:
              _context4.prev = 2;
              _t3 = _context4["catch"](0);
              console.error('导出失败:', _t3);
              this.$message.error('导出失败：' + (_t3.message || '网络异常'));
            case 3:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[0, 2]]);
      }));
      function exportMembers() {
        return _exportMembers2.apply(this, arguments);
      }
      return exportMembers;
    }(),
    // 充值
    handleRecharge: function handleRecharge(row) {
      this.closePopover(row.id || row.userId);
      var newTabName = "recharge-".concat(++this.tabIndex);
      this.editTabs.push({
        title: "\u4F1A\u5458\u50A8\u503C\u8BB0\u5F55 - ".concat(row.nickName),
        name: newTabName,
        type: 'recharge',
        memberData: _objectSpread(_objectSpread({}, row), {}, {
          userId: row.id || row.userId // 确保userId被传递
        })
      });
      this.activeTab = newTabName;
    },
    // 发券
    handleSendCoupon: function handleSendCoupon(row) {
      this.closePopover(row.id || row.userId);
      var newTabName = "coupon-".concat(++this.tabIndex);
      this.editTabs.push({
        title: "\u4F18\u60E0\u5238 - ".concat(row.nickName),
        name: newTabName,
        type: 'coupon',
        memberData: _objectSpread({}, row)
      });
      this.activeTab = newTabName;
    },
    // 兑换
    handleExchange: function handleExchange(row) {
      this.closePopover(row.id || row.userId);
      var newTabName = "exchange-".concat(++this.tabIndex);
      this.editTabs.push({
        title: "\u5151\u6362\u5217\u8868 - ".concat(row.nickName),
        name: newTabName,
        type: 'exchange',
        memberData: _objectSpread({}, row)
      });
      this.activeTab = newTabName;
    },
    // 订单
    handleOrder: function handleOrder(row) {
      this.closePopover(row.id || row.userId);
      var userId = row.id || row.userId;
      this.$router.push({
        path: '/order/orderManage',
        query: {
          userId: userId
        }
      });
    },
    // 明细
    handleDetails: function () {
      var _handleDetails = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee5(row) {
        var response, memberData, newTabName, _memberData, _newTabName, _t4;
        return regeneratorRuntime.wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              this.closePopover(row.id || row.userId);
              _context5.prev = 1;
              _context5.next = 2;
              return (0, _memberManagement.getMemberById)(row.id || row.userId);
            case 2:
              response = _context5.sent;
              memberData = row;
              if (response.code === 200 && response.data) {
                // 如果API返回了更详细的数据，使用API数据
                memberData = _objectSpread(_objectSpread({}, row), response.data);
              }

              // 确保userId被正确传递
              memberData.userId = row.id || row.userId;
              newTabName = "accountDetail-".concat(++this.tabIndex);
              this.editTabs.push({
                title: "\u8D26\u6237\u53D8\u52A8\u660E\u7EC6 - ".concat(memberData.nickName),
                name: newTabName,
                type: 'accountDetail',
                memberData: memberData
              });
              this.activeTab = newTabName;
              _context5.next = 4;
              break;
            case 3:
              _context5.prev = 3;
              _t4 = _context5["catch"](1);
              console.error('获取用户明细失败:', _t4);
              this.$message.error('获取用户明细失败');

              // 即使API调用失败，也显示明细页面（使用现有数据）
              _memberData = _objectSpread(_objectSpread({}, row), {}, {
                userId: row.id || row.userId
              });
              _newTabName = "accountDetail-".concat(++this.tabIndex);
              this.editTabs.push({
                title: "\u8D26\u6237\u53D8\u52A8\u660E\u7EC6 - ".concat(_memberData.nickName),
                name: _newTabName,
                type: 'accountDetail',
                memberData: _memberData
              });
              this.activeTab = _newTabName;
            case 4:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[1, 3]]);
      }));
      function handleDetails(_x3) {
        return _handleDetails.apply(this, arguments);
      }
      return handleDetails;
    }(),
    // 地址
    handleAddress: function handleAddress(row) {
      this.closePopover(row.id || row.userId);
      var newTabName = "address-".concat(++this.tabIndex);
      this.editTabs.push({
        title: "\u4F1A\u5458\u5730\u5740 - ".concat(row.nickName),
        name: newTabName,
        type: 'address',
        memberData: _objectSpread({}, row)
      });
      this.activeTab = newTabName;
    },
    // 同步
    handleSync: function () {
      var _handleSync = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee6(row) {
        var _t5;
        return regeneratorRuntime.wrap(function (_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              this.closePopover(row.id || row.userId);
              _context6.prev = 1;
              _context6.next = 2;
              return (0, _memberManagement.syncMember)(row.id || row.userId);
            case 2:
              this.$message.success("\u540C\u6B65\u4F1A\u5458 ".concat(row.nickName, " \u6210\u529F"));
              this.fetchMemberList(); // 重新获取列表
              _context6.next = 4;
              break;
            case 3:
              _context6.prev = 3;
              _t5 = _context6["catch"](1);
              this.$message.error('同步失败');
            case 4:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this, [[1, 3]]);
      }));
      function handleSync(_x4) {
        return _handleSync.apply(this, arguments);
      }
      return handleSync;
    }(),
    // 解绑
    handleUnbind: function handleUnbind(row) {
      var _this3 = this;
      this.closePopover(row.id || row.userId);
      this.$confirm("\u786E\u8BA4\u89E3\u7ED1\u4F1A\u5458 ".concat(row.nickName, "?"), '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var _t6;
        return regeneratorRuntime.wrap(function (_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.prev = 0;
              _context7.next = 1;
              return (0, _memberManagement.unbindMember)(row.id || row.userId);
            case 1:
              _this3.$message.success('解绑成功');
              _this3.fetchMemberList(); // 重新获取列表
              _context7.next = 3;
              break;
            case 2:
              _context7.prev = 2;
              _t6 = _context7["catch"](0);
              _this3.$message.error('解绑失败');
            case 3:
            case "end":
              return _context7.stop();
          }
        }, _callee7, null, [[0, 2]]);
      })));
    },
    // 编辑
    handleEdit: function () {
      var _handleEdit = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee8(row) {
        var response, memberData, newTabName, _newTabName2, _t7;
        return regeneratorRuntime.wrap(function (_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              this.closePopover(row.id || row.userId);
              _context8.prev = 1;
              _context8.next = 2;
              return (0, _memberManagement.getMemberById)(row.id || row.userId);
            case 2:
              response = _context8.sent;
              memberData = row;
              if (response.code === 200 && response.data) {
                // 如果API返回了更详细的数据，使用API数据
                memberData = _objectSpread(_objectSpread({}, row), response.data);
              }
              newTabName = "edit-".concat(++this.tabIndex);
              this.editTabs.push({
                title: "\u7F16\u8F91 - ".concat(memberData.nickName),
                name: newTabName,
                type: 'edit',
                memberData: memberData
              });
              this.activeTab = newTabName;
              _context8.next = 4;
              break;
            case 3:
              _context8.prev = 3;
              _t7 = _context8["catch"](1);
              this.$message.error('获取用户详细失败');

              // 即使API调用失败，也显示编辑页面（使用现有数据）
              _newTabName2 = "edit-".concat(++this.tabIndex);
              this.editTabs.push({
                title: "\u7F16\u8F91 - ".concat(row.nickName),
                name: _newTabName2,
                type: 'edit',
                memberData: _objectSpread({}, row)
              });
              this.activeTab = _newTabName2;
            case 4:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this, [[1, 3]]);
      }));
      function handleEdit(_x5) {
        return _handleEdit.apply(this, arguments);
      }
      return handleEdit;
    }(),
    // 日志
    handleLog: function handleLog(row) {
      this.closePopover(row.id || row.userId);
      var newTabName = "log-".concat(++this.tabIndex);
      this.editTabs.push({
        title: "\u4F1A\u5458\u65E5\u5FD7 - ".concat(row.nickName),
        name: newTabName,
        type: 'log',
        memberData: _objectSpread({}, row)
      });
      this.activeTab = newTabName;
    },
    // 删除
    handleDelete: function handleDelete(row) {
      var _this4 = this;
      this.closePopover(row.id || row.userId);
      this.$confirm("\u786E\u8BA4\u5220\u9664\u4F1A\u5458 ".concat(row.nickName, "?"), '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var _t8;
        return regeneratorRuntime.wrap(function (_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.prev = 0;
              _this4.loading = true; // 添加加载框
              _context9.next = 1;
              return (0, _memberManagement.deleteMember)(row.id || row.userId);
            case 1:
              _this4.$message.success('删除成功');
              _this4.fetchMemberList(); // 重新获取列表
              _context9.next = 3;
              break;
            case 2:
              _context9.prev = 2;
              _t8 = _context9["catch"](0);
              _this4.$message.error('删除失败');
            case 3:
              _context9.prev = 3;
              _this4.loading = false; // 关闭加载框
              return _context9.finish(3);
            case 4:
            case "end":
              return _context9.stop();
          }
        }, _callee9, null, [[0, 2, 3, 4]]);
      })));
    },
    // 汇总
    handleSummary: function handleSummary(row) {
      this.closePopover(row.id || row.userId);
      var newTabName = "summary-".concat(++this.tabIndex);
      this.editTabs.push({
        title: "\u4F1A\u5458\u6C47\u603B - ".concat(row.nickName),
        name: newTabName,
        type: 'summary',
        memberData: _objectSpread({}, row)
      });
      this.activeTab = newTabName;
    },
    // 发券明细
    handleCouponDetail: function handleCouponDetail(row) {
      this.closePopover(row.id || row.userId);
      var newTabName = "couponDetail-".concat(++this.tabIndex);
      this.editTabs.push({
        title: "\u53D1\u5238\u660E\u7EC6 - ".concat(row.nickName),
        name: newTabName,
        type: 'couponDetail',
        memberData: _objectSpread(_objectSpread({}, row), {}, {
          userId: row.id || row.userId
        })
      });
      this.activeTab = newTabName;
    },
    /**
     * 处理打开订单详情
     * @param {Object} data - 订单数据和标题
     */
    handleOpenOrderDetail: function handleOpenOrderDetail(data) {
      var newTabName = "orderDetail-".concat(++this.tabIndex);
      this.editTabs.push({
        title: data.title,
        name: newTabName,
        type: 'orderDetail',
        orderData: data.orderData
      });
      this.activeTab = newTabName;
    },
    removeTab: function removeTab(targetName) {
      var tabs = this.editTabs;
      var activeName = this.activeTab;
      if (activeName === targetName) {
        tabs.forEach(function (tab, index) {
          if (tab.name === targetName) {
            var nextTab = tabs[index + 1] || tabs[index - 1];
            if (nextTab) {
              activeName = nextTab.name;
            } else {
              activeName = 'list';
            }
          }
        });
      }
      this.activeTab = activeName;
      this.editTabs = tabs.filter(function (tab) {
        return tab.name !== targetName;
      });
    },
    /**
     * 处理表单提交
     * @param {Object} formData - 表单数据
     */
    onSubmit: function () {
      var _onSubmit = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee0(formData) {
        var response, _response, _t9;
        return regeneratorRuntime.wrap(function (_context0) {
          while (1) switch (_context0.prev = _context0.next) {
            case 0:
              _context0.prev = 0;
              if (!this.activeTab.startsWith('add')) {
                _context0.next = 2;
                break;
              }
              _context0.next = 1;
              return (0, _memberManagement.insertMember)(formData);
            case 1:
              response = _context0.sent;
              this.$message.success('添加成功');
              _context0.next = 4;
              break;
            case 2:
              _context0.next = 3;
              return (0, _memberManagement.updateMember)(formData);
            case 3:
              _response = _context0.sent;
              this.$message.success('编辑成功');
            case 4:
              this.fetchMemberList(); // 重新获取列表
              this.removeTab(this.activeTab);
              _context0.next = 6;
              break;
            case 5:
              _context0.prev = 5;
              _t9 = _context0["catch"](0);
              this.$message.error('操作失败：' + (_t9.message || '未知错误'));
            case 6:
            case "end":
              return _context0.stop();
          }
        }, _callee0, this, [[0, 5]]);
      }));
      function onSubmit(_x6) {
        return _onSubmit.apply(this, arguments);
      }
      return onSubmit;
    }(),
    // 分页大小改变
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.fetchMemberList();
    },
    // 当前页改变
    handleCurrentChange: function handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchMemberList();
    },
    // 格式化时间
    formatTime: function formatTime(time) {
      if (!time) return '';
      return (0, _index.parseTime)(time, '{y}-{m}-{d} {h}:{i}:{s}');
    },
    // 获取注册方式文本
    getRegisterTypeText: function getRegisterTypeText(type) {
      var typeMap = {
        0: '系统注册',
        2: '点餐',
        3: '口碑',
        4: '社交',
        5: '支付宝'
      };
      return typeMap[type] || '未知';
    },
    // 获取微信类型文本
    getWxTypeText: function getWxTypeText(type) {
      var typeMap = {
        2: '点餐',
        3: '口碑',
        4: '社交',
        5: '支付宝'
      };
      return typeMap[type] || '未知';
    },
    // 获取卡型列表
    fetchCardTypeList: function () {
      var _fetchCardTypeList = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee1() {
        var response, _t0;
        return regeneratorRuntime.wrap(function (_context1) {
          while (1) switch (_context1.prev = _context1.next) {
            case 0:
              _context1.prev = 0;
              _context1.next = 1;
              return (0, _gradeInfo.xyRuleVipGradeSelPage)({
                page: 1,
                limit: 100
              });
            case 1:
              response = _context1.sent;
              if (response.code === 200 && response.records) {
                this.cardTypeList = response.records.map(function (item) {
                  return {
                    value: item.id,
                    label: item.name
                  };
                });
              } else {
                console.error('获取卡型列表失败:', response.message);
              }
              _context1.next = 3;
              break;
            case 2:
              _context1.prev = 2;
              _t0 = _context1["catch"](0);
              console.error('获取卡型列表失败:', _t0);
            case 3:
            case "end":
              return _context1.stop();
          }
        }, _callee1, this, [[0, 2]]);
      }));
      function fetchCardTypeList() {
        return _fetchCardTypeList.apply(this, arguments);
      }
      return fetchCardTypeList;
    }()
  },
  created: function created() {
    // 接收路由参数中的手机号
    if (this.$route.query.mobilePhone) {
      this.searchForm.mobilePhone = this.$route.query.mobilePhone;
      this.$router.replace({
        query: _objectSpread(_objectSpread({}, this.$route.query), {}, {
          mobilePhone: undefined
        })
      });
    }
    this.fetchMemberList();
    this.fetchCardTypeList();
  },
  mounted: function mounted() {
    // 初始化时获取会员列表数据
    this.fetchMemberList();
  }
};